<template>
  <div>
    <!-- <el-button
      type="primary"
      icon="el-icon-plus"
      @click="setUserinfoDetailDialogVisible = true"
      >添加</el-button
    > -->
    <!-- <el-dialog
      :visible="userinfoDetailDialogVisible"
      title="修改个人信息"
      width="800px"
      @close="closeDialog"
    >
      <el-form :model="changeForm" ref="form" label-width="130px">
        <el-form-item label="注册时间：">
          {{ changeForm.createTime }}
        </el-form-item>
        <el-form-item label="注册来源：">
          <span>{{ changeForm.__registerFrom }}</span>
        </el-form-item>
        <el-form-item label="用户ID：">
          {{ changeForm.id }} <el-button size="mini" type="danger" @click="resetLoginPassword(changeForm.id)">重置登录密码</el-button>
        </el-form-item>
        <el-form-item label="用户账号：">
          {{ changeForm.username }}
        </el-form-item>
        <el-form-item label="用户状态：">
          <span>{{
            changeForm.__userStatus && changeForm.__userStatus.text
          }}</span>
        </el-form-item>
        <el-form-item label="实名认证：">
          <span>
            {{ changeForm.__userStatus && changeForm.__idNoStatus.text }}</span
          >
        </el-form-item>
        <el-form-item label="谷歌认证：">
          <span>{{
            changeForm.__googleSecurityStatus &&
              changeForm.__googleSecurityStatus.text
          }}</span>
        </el-form-item>
        <el-form-item label="银行卡绑定状态：">
          <span>{{
            changeForm.__bankAuthStatus && changeForm.__bankAuthStatus.text
          }}</span>
        </el-form-item>
        <el-form-item label="是否迁移用户：">
          <span v-if="changeForm.oldOrNew === 'old'">是</span>
          <span v-else>否</span>
        </el-form-item>
        <el-form-item label="冻结状态：">
          <span v-if="changeForm.userStatus == 0">否</span>
          <span v-else-if="changeForm.userStatus == -1"
            >是（管理员ID：{{ changeForm.adminId }}，原因：{{
              changeForm.content
            }}）</span
          >
        </el-form-item>
        <el-form-item label="电话号码：">
          <el-input v-model="changeForm.tel">
            <el-select v-model="changeForm.telCountryCode" slot="append">
              <el-option
                v-for="(n, index) in countryCodeList"
                :key="index"
                :label="`+${n.code}`"
                :value="n.code"
              >
              </el-option>
            </el-select>
          </el-input>
        </el-form-item>
        <el-form-item label="邮箱：">
          <el-input v-model="changeForm.email"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取消</el-button>
        <el-button type="primary" @click="handleSave">保存</el-button>
      </span>
    </el-dialog> -->
    <el-dialog
      :visible="userinfoDetailDialogVisible"
      title="修改用户信息"
      width="600px"
      @close="closeDialog"
      :before-close="handleClose"
    >
      <el-form
        ref="elForm"
        :model="updateForm"
        size="medium"
        label-width="140px"
      >
        <el-row :gutter="15">
          <el-form-item label="用户的userID" prop="userId">
            <!-- <el-input
              v-model="accountInfo.userId"
              placeholder="请输入用户的userId"
              clearable
              :style="{ width: '100%' }"
            >
            </el-input> -->
            <el-input v-model="updateForm.accountInfo.userId" disabled>
            </el-input>
          </el-form-item>
          <el-form-item label="用户类型">
            <el-select
              v-model="updateForm.accountInfo.type"
              placeholder="请选择账户类型用户类型"
              clearable
            >
              <el-option
                v-for="(item, index) in typeOptions"
                :key="index"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否可交易">
            <el-switch
              v-model="updateForm.accountInfo.allowTrade"
              active-color="#49F909"
            ></el-switch>
          </el-form-item>
          <el-form-item label="是否可划入">
            <el-switch
              v-model="updateForm.accountInfo.allowTransfer"
              active-color="#49F909"
            ></el-switch>
          </el-form-item>
          <!-- <el-form-item label="是否开关仓"  >
            <el-switch
              v-model="updateForm.accountInfo.allowOpenPosition"
              active-color="#49F909"
            ></el-switch>
          </el-form-item> -->
          <el-form-item label="用户状态">
            <el-select
              v-model="updateForm.userInfo.state"
              placeholder="请选择用户状态"
              clearable
            >
              <el-option
                v-for="(item, index) in stateOptions"
                :key="index"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="用户组别">
            <el-select
              v-model="updateForm.userInfo.userGroupId"
              placeholder="请选择用户组别"
              clearable
            >
              <el-option
                v-for="(item, index) in userGroupIdOptions"
                :key="index"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer">
        <el-button @click="close">取消</el-button>
        <el-button type="primary" @click="handleSave('elForm')">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from "vuex";

export default {
  name: "updatedialog",
  props: ["updateForm"],
  data() {
    return {
      changeForm: {
        id: "",
        tel: "",
        email: "",
        telCountryCode: "86",
      },
      accountInfo: {
        userId: null,
        type: 0,
        allowTrade: true,
        allowTransfer: true,
      },
      userInfo: {
        state: 1,
        userGroupId: 1,
      },
      //  rules: {
      //   userId: [
      //     {
      //       required: true,
      //       message: "请输入用户的userId",
      //       trigger: "blur",
      //     },
      //   ],},
      typeOptions: [
        {
          label: "普通账户",
          value: 0,
        },
        {
          label: "量化账户",
          value: 1,
        },
        {
          label: "风险保证金账户",
          value: 2,
        },
      ],
      stateOptions: [
        {
          label: "0",
          value: 0,
        },
        {
          label: "1",
          value: 1,
        },
      ],
      userGroupIdOptions: [
        {
          label: "1",
          value: 1,
        },
        {
          label: "2",
          value: 2,
        },
        {
          label: "3",
          value: 3,
        },
      ],
    };
  },
  watch: {
    userinfoDetailDialogVisible() {
      this.elForm = { ...this.updateForm };
    },
  },
  computed: {
    ...mapState("user", [
      "userinfoDetail",
      "userinfoDetailDialogVisible",
      "countryCodeList",
    ]),
    ...mapGetters("user", ["userList"]),
  },
  methods: {
    ...mapMutations("user", [
      "setUserinfoDetailDialogVisible",
      "setUserinfoDetail",
    ]),
    ...mapActions("user", [
      "updatInfo",
      "coutryCode",
      "resetPassword",
      "updateUser",
    ]),
    closeDialog() {
      this.setUserinfoDetailDialogVisible(false);
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    close() {
      this.setUserinfoDetailDialogVisible(false);
      this.$refs["elForm"].resetFields();
    },
    handleSave() {
      const accountInfo = this.updateForm.accountInfo;
      const userInfo = this.updateForm.userInfo;
      this.updateUser({
        userId: this.updateForm.accountInfo.userId,
        state: this.updateForm.userInfo.state,
        userGroupId: this.updateForm.accountInfo.userGroupId,
        allowTrade: this.updateForm.accountInfo.allowTrade,
        allowTransfer: this.updateForm.accountInfo.allowTransfer,
        type: this.updateForm.accountInfo.type,
      }).then((res) => {
        if (res.code == 0) {
          this.$message.success("操作成功！");
          this.close();
        } else {
          this.$message.error("操作失败！");
        }
      });
    },
    resetLoginPassword(id) {
      this.resetPassword({ userId: id }).then(() => {
        this.$message.success("重置成功！");
      });
    },
  },
  created() {
    // this.coutryCode();
  },
};
</script>

<style lang="less" scoped>
// ::v-deep.el-select {
// .el-input__inner {
//   width: 100px;
// }
// }
</style>
